import { Component, input, output } from '@angular/core';
import { headerToggleIconAnimation } from '../../shared/animations/sidebar.animation';
import { UseUIBasicIconDirective } from '../../ui-components/atoms/icons/ui-basic.directive';
import { IconButtonDirective } from '../../ui-components/molecules/icon-button.directive';

export enum HeaderStyle {
  gradient = 'gradient',
  transparent = 'transparent',
}

@Component({
  selector: 'dmcom-header-desktop',
  animations: [headerToggleIconAnimation],
  imports: [UseUIBasicIconDirective, IconButtonDirective],
  template: `
    <div
      class="header absolute z-20 flex flex-col justify-end top-0 left-0 h-[var(--header-height)] transition-right duration-600 ease-in-out"
      [class.right-[490px]]="isRightPanelOpened()"
      [class.right-14]="!isRightPanelOpened()"
    >
      <div
        class="pl-24 pt-20 flex-1 w-full"
        [class.bg-transparent]="headerStyle() === 'transparent'"
        [class.bg-shades-white]="headerStyle() === 'gradient'"
      >
        <div class="flex items-center justify-between gap-2">
          <button
            dmcomIconButton
            [color]="headerStyle() === 'transparent' ? 'neutral-transparent' : 'neutral'"
            variant="icon"
            size="lgmd"
            (click)="onToggleSidebar()"
            [class.pointer-events-none]="isSidebarOpened()"
            [class.pointer-events-auto]="!isSidebarOpened()"
            [@headerToggleIconAnimation]="isSidebarOpened() ? 'opened' : 'closed'"
          >
            <svg dmcomUseUIBasicIcon="sliderClosed"></svg>
          </button>
        </div>
      </div>
      <div
        class="h-24"
        [class.bg-transparent]="headerStyle() === 'transparent'"
        [class.bg-gradient-fade-to-white]="headerStyle() === 'gradient'"
      ></div>
    </div>
  `,
  styles: [``],
})
export class HeaderDesktopResponsive {
  public readonly isSidebarOpened = input.required<boolean>();
  public readonly isRightPanelOpened = input.required<boolean>();
  public readonly isRightPanelMaximized = input.required<boolean>();
  public readonly toggleSidebar = output<void>();
  public readonly headerStyle = input<HeaderStyle>(HeaderStyle.transparent);

  onToggleSidebar() {
    this.toggleSidebar.emit();
  }
}
